export default {
	install: (Vue) => {
		Vue.prototype.$onReload = function (callback) {
			this.$ls.on('reloadCounter', callback);
		};
		Vue.prototype.$triggerReload = function () {
			this.$ls.set('reloadCounter', this.$ls.get('reloadCounter', 0)+1);
			this.$modalBus.$emit('RELOAD', '');
		};

		Vue.prototype.$onRequestReload = function (callback) {
			this.$ls.on('reloadRequestCounter', callback);
		};
		Vue.prototype.$triggerRequestReload = function () {
			this.$ls.set('reloadRequestCounter', this.$ls.get('reloadRequestCounter', 0)+1);
		};
	}
};
